import React, { Dispatch, useReducer } from 'react';
import SellerListingCardContext from './SellerListingCardContext';
import SellerListingCard from './SellerListingCard';
import SellerListingCardInsights from './SellerListingCardInsights';
import { Listing } from '@reverbdotcom/commons/src/gql/graphql';
import { RCToast } from '@reverbdotcom/cadence/components';
import listingCardReducer, { ICardState } from './sellerListingCardReducer';
import { useEppoAssignment, useUser } from '@reverbdotcom/commons/src/user_hooks';
import eppoFlags from '@reverbdotcom/commons/src/eppoFlags.json';
import { EppoSubjectTypes } from '@reverbdotcom/commons/src/eppo/eppoExperimentHelpers';

interface IExternalProps {
  listing: Listing;
}
interface IListingUpdatedToastProps {
  cardState: ICardState;
  dispatch: Dispatch<any>;
}

function ListingUpdatedToast({ cardState, dispatch }: IListingUpdatedToastProps) {
  return <RCToast
    delayInterval="short"
    onClose={() => {
      dispatch({
        type: 'hideToast',
      });
    }}
    text={cardState.toast?.message}
    theme={cardState.toast?.isSuccess ? 'success' : 'error'}
    isOpen={cardState.toast?.isOpen}
    link={cardState.toast?.link}
  />;
}

function SellerListingCardContainer({
  listing,
}: IExternalProps) {
  const initialCardState = {
    toast: {
      isOpen: false,
      message: '',
      isSuccess: true,
    },
  };

  const [cardState, dispatch] = useReducer(
    listingCardReducer,
    initialCardState,
  );

  const user = useUser();
  const insightsCardVariant =
    useEppoAssignment({
      flagKey: eppoFlags.LISTINGS_INSIGHTS_FILTER_CARD,
      subjectKey: user.id,
      subjectType: EppoSubjectTypes.USER_ID,
    }) === 'treatment';

  const CardComponent = insightsCardVariant ? SellerListingCardInsights : SellerListingCard;

  return (
    <>
      <SellerListingCardContext.Provider
        value={{
          cardState,
          dispatch,
        }}
      >
        <CardComponent
          listing={listing}
        />
      </SellerListingCardContext.Provider>
      <ListingUpdatedToast
        cardState={cardState}
        dispatch={dispatch}
      />
    </>
  );
}

export default SellerListingCardContainer;
